import { processingBillingConfigSchema } from "@redotech/redo-return-settings-common/processing-billing-config";
import * as z from "zod";
import { pendingSettingsChange } from "./pending-settings-change";

/** A protected change that the saver must choose a disposition for. */
export const previewProtectedChange = z.object({
  resource: z.string(),
  resourceId: z.string(),
  path: z.string(),
  label: z.string().nullable(),
  prev: z.unknown(),
  next: z.unknown(),
});

/**
 * Preview the disposition of a proposed team.settings save: which changes apply
 * immediately (non-protected), which need approval (protected), whether the
 * saver can bypass them all, the connected open contract (if any), and any
 * pending changes that already exist for the targeted settings.
 */
export const previewTeamSettingsChanges = {
  name: "previewTeamSettingsChanges" as const,
  input: z.object({
    teamId: z.string(),
    settings: z.record(z.string(), z.unknown()),
    billing: processingBillingConfigSchema.optional(),
  }),
  output: z.object({
    /** Non-protected changes that will be carried out immediately. */
    nonProtectedCount: z.number(),
    protected: z.array(previewProtectedChange),
    /** Whether the saver may bypass every protected change (apply directly). */
    canBypassAll: z.boolean(),
    /** Pending changes that already exist for the settings being changed. */
    existingPending: z.array(pendingSettingsChange),
  }),
};

export type PreviewTeamSettingsChangesResult = z.infer<
  typeof previewTeamSettingsChanges.output
>;
